module.exports = {
  loginPath: 'https://primafrio-tengri.myapi.es/app',
  apiPath: 'https://primafrio-tengri.myapi.es/app',
  firebaseConfig: {
    apiKey: "AIzaSyDkSd1ayNVCwdNLFCCCzsNK2_7vGZUEyrM",
    authDomain: "primafrio-pro.firebaseapp.com",
    databaseURL: "https://primafrio-pro.firebaseio.com",
    projectId: "primafrio-pro",
    storageBucket: "primafrio-pro.appspot.com",
    messagingSenderId: "458997244769",
    appId: "1:458997244769:web:f2326d4f55068d95815b20"
  }
};



// WEBPACK FOOTER //
// ./src/env/production.js